import { initializeShellFederation } from './federation';
import { renderStartupError } from './startup-error';

async function fetchRuntimeConfigPayload(): Promise<unknown | null> {
  const response = await fetch('/runtime-config.json', {
    cache: 'no-store',
    credentials: 'same-origin',
  });

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(
      `Falha ao carregar configuração de runtime: HTTP ${response.status}.`,
    );
  }

  return response.json();
}

function federationManifestUrl(payload: unknown): string | undefined {
  if (typeof payload !== 'object' || payload === null) return undefined;
  const value = (payload as Record<string, unknown>)['federationManifestUrl'];
  return typeof value === 'string' && value.trim() ? value : undefined;
}

async function startApplication(): Promise<void> {
  const payload = await fetchRuntimeConfigPayload();
  await initializeShellFederation(federationManifestUrl(payload));

  // Use um especificador indireto para que o Nx não classifique toda a
  // biblioteca como lazy; em runtime, o mapa federado resolve esse nome.
  const runtimeConfigModule = '@bolaoclub/shared/runtime-config';
  const { clearRuntimeConfig, installRuntimeConfig } = (await import(
    runtimeConfigModule
  )) as {
    clearRuntimeConfig(): void;
    installRuntimeConfig(value: unknown): unknown;
  };
  if (payload === null) clearRuntimeConfig();
  else installRuntimeConfig(payload);

  await import('./bootstrap');
}

void startApplication().catch((error: unknown) => {
  renderStartupError('Não foi possível iniciar o shell da plataforma.', error);
});
